import { toCssHex, type Rgba } from '../color.ts';
import {
  FACTORY_ACCENT_HEX,
  FACTORY_DECK_HEX,
  FACTORY_HULL_HEX,
} from './limits.ts';

const HULL_TOKEN = '___BOAT_HULL___';
const DECK_TOKEN = '___BOAT_DECK___';
const ACCENT_TOKEN = '___BOAT_ACCENT___';

/**
 * Repaints the hull, deck, and windshield fills of `boat.svg`.
 * Other paths (cockpit, stripe, windows, transom) stay as authored.
 * Tokens keep a new hull colour from being rewritten when it matches another factory fill.
 */
export function paintBoatSvg(
  source: string,
  colors: { hull: Rgba; deck: Rgba; accent: Rgba },
): string {
  return source
    .replaceAll(FACTORY_HULL_HEX, HULL_TOKEN)
    .replaceAll(FACTORY_DECK_HEX, DECK_TOKEN)
    .replaceAll(FACTORY_ACCENT_HEX, ACCENT_TOKEN)
    .replaceAll(HULL_TOKEN, toCssHex(colors.hull))
    .replaceAll(DECK_TOKEN, toCssHex(colors.deck))
    .replaceAll(ACCENT_TOKEN, toCssHex(colors.accent));
}
